// extracted by mini-css-extract-plugin
export var avatarContainer = "_ay-0";
export var avatarTypingWave = "_ay-i";
export var gray = "_ay-f";
export var green = "_ay-c";
export var icon = "_ay-9";
export var image = "_ay-1";
export var lg = "_ay-6";
export var md = "_ay-5";
export var presenceDot = "_ay-b";
export var red = "_ay-d";
export var sm = "_ay-4";
export var status = "_ay-a";
export var typingDot = "_ay-h";
export var typingPill = "_ay-g";
export var xl = "_ay-7";
export var xs = "_ay-3";
export var xxl = "_ay-8";
export var xxs = "_ay-2";
export var yellow = "_ay-e";